// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"2b7807ad","395":"08063482","453":"d855a71b","738":"f637b978","868":"e6c0aa20"}[chunkId] + ".chunk.js";
};